import { Icon, IconType } from '@aibees/shared/components';
import { HighlightableContent } from '@aibees/shared/features';
import { Stack, useTheme } from '@mui/material';
import { ReactNode } from 'react';
import * as SX from '../sx';

interface InfoRowProps {
  icon: IconType;
  label: string;
  children: ReactNode;
}

export const InfoRow = ({ icon, label, children }: InfoRowProps) => {
  const theme = useTheme();

  return (
    <Stack sx={SX.row}>
      <Stack sx={SX.titleRow}>
        <Icon name={icon} color={theme.palette.grey[500]} size={20} />
        <HighlightableContent
          content={label}
          variant="body3"
          fontWeight="light"
          color="grey.700"
        />
      </Stack>
      <Stack sx={SX.titleRow}>{children}</Stack>
    </Stack>
  );
};
